module.exports = __webpack_public_path__ + "media/images/test-hr-49c2568fb28213ef8f59435deb3c1bb6.png";